export function parseWorkload(app) {
    return {
        ChangeColorInDarkMode: app.CollectorId === 'Dynamics',
        Color: app.BackgroundColor,
        Id: app.Id,
        AppId: app.Id,
        CollectorId: app.CollectorId,
        Title: app.AriaLabel ? app.AriaLabel : '',
        SubText: app.Subtitle,
        Text: app.Title,
        // TODO: Remove 'as any' typing by updating shell typings
        IsNativeClientOnlyApp: app.isNativeClientOnlyApp,
        Url: !!app.LaunchFullUrl ? app.LaunchFullUrl.trim() : '',
        IconUnicodeCodepointCssClass: 'ms-fcl-tp ms-Icon ms-Icon--OfficeAddinsLogo',
        ThirdPartyIcon: app.IconAnonymousUrl ? app.IconAnonymousUrl : null,
        Referral: app.Id,
        IsThirdParty: true,
    };
}
//# sourceMappingURL=parseWorkload.js.map